import { LoadablePaint } from '@confluence/loadable';

export const LazySecurityConfigurationPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SecurityConfigurationContainer" */ '../src/SecurityConfiguration/SecurityConfigurationPage.tsx'
			)
		).SecurityConfigurationPage,
});
